import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AbstractProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/AbstractProgress';
import { OrderProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/Progress/OrderProgress';
import { LoanProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/Progress/LoanProgress';
import { A2APaymentProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/Progress/A2APaymentProgress';
import { CardPaymentProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/Progress/CardPaymentProgress';

export class FactoryProgress {
  static create(paymentMethodId: string, paymentMethodType: PaymentMethodType): AbstractProgress {
    if ([PaymentMethodType.CARD_PAYMENT].includes(paymentMethodType)) {
      return new CardPaymentProgress(paymentMethodId, paymentMethodType);
    }
    if ([PaymentMethodType.A2A_PAYMENT].includes(paymentMethodType)) {
      return new A2APaymentProgress(paymentMethodId, paymentMethodType);
    }

    if ([PaymentMethodType.BNPL_INSTALMENTS, PaymentMethodType.BNPL_SPLIT_PAY].includes(paymentMethodType)) {
      return new OrderProgress(paymentMethodId, paymentMethodType);
    }

    return new LoanProgress(paymentMethodId, paymentMethodType);
  }
}
